import { Spin } from 'antd';
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import Pages from './pages';
import Farmer from './farmer';
import Investor from './investor';
import User from './user';
import Borrower from './borrower';
import Projects from './project';
import FarmHistory from './farmHistory';
import Soil from './soil';
import Farm from './farm';
import Blog from './Blog';
import Farmhub from './farmhub';
import Stock from './stock';
import Report from './report';
import Owner from './owner';
import Facilitator from './facilitator';
import Device from './device';
import Member from './member';
import Investment from './investment';

import Subscription from './subscription';
import withAdminLayout from '../../layout/withAdminLayout';

const Admin = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Pages />} />
        <Route path="pages/*" element={<Pages />} />
        {/* Investor */}
        <Route path="investor/*" element={<Investor />} />
        {/* <Route path="investor/*" element={<Investor />} /> */}
        <Route path="investment/*" element={<Investment />} />
        {/* user */}
        <Route path="user/*" element={<User />} />
        {/* Borrower */}
        <Route path="borrower/*" element={<Borrower />} />
        <Route path="project/*" element={<Projects />} />
        <Route path="member/*" element={<Member />} />
        {/* Facilitator */}
        <Route path="farmhub/*" element={<Farmhub />} />
        <Route path="facilitator/*" element={<Facilitator />} />
        {/* Other routes */}
        <Route path="farmer/*" element={<Farmer />} />
        <Route path="farm/*" element={<Farm />} />
        <Route path="stock/*" element={<Stock />} />
        <Route path="farmHistory/*" element={<FarmHistory />} />
        <Route path="soil/*" element={<Soil />} />
        <Route path="blog/*" element={<Blog />} />
        {/* report */}
        <Route path="report/*" element={<Report />} />
        <Route path="owner/*" element={<Owner />} />
        <Route path="device/*" element={<Device />} />
        <Route path="subscription/*" element={<Subscription />} />
        <Route path="soil-test-results/*" element={<Subscription />} />
        <Route path="investors/*" element={<Investor />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
